import { useEffect, useState } from 'react';

// Only elapsed time in a visible, focused tab counts as reading time.
export default function usePaymentCountdown(durationMs = 3000) {
  const [remainingMs, setRemainingMs] = useState(durationMs);
  useEffect(() => {
    let remaining = durationMs;
    let active = !document.hidden && document.hasFocus();
    let last = performance.now();
    const sample = () => {
      const now = performance.now();
      if (active) remaining = Math.max(0, remaining - (now - last));
      last = now;
      setRemainingMs(remaining);
      if (remaining === 0) window.clearInterval(interval);
    };
    const change = () => {
      sample();
      active = !document.hidden && document.hasFocus();
    };
    const interval = window.setInterval(sample, 20);
    document.addEventListener('visibilitychange', change);
    window.addEventListener('focus', change);
    window.addEventListener('blur', change);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', change);
      window.removeEventListener('focus', change);
      window.removeEventListener('blur', change);
    };
  }, [durationMs]);
  return { seconds: Math.ceil(remainingMs / 1000), progress: 1 - remainingMs / durationMs };
}
